import i18n from 'src/i18n';

export default {
  getWxAuthCgi: '/mp/oauth/url',
  unbindtWxCgi: '/mp/rest/wxInfo',
  unbindtQQCgi: '/mp/accountInfo/unbindQQAccount',
  reloadStatusCgi: '/mp/accountInfo/getWxMaterial',
  syncStatusText: {
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    0: '初始化状态成功',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    1: '拉取微信菜单',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    2: '拉取微信自动回复',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    3: '拉取微信素材列表',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    4: '拉取微信图文素材详情',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    5: '拉取微信图片素材',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    6: '同步图片素材',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    7: '同步图文素材',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    8: '同步自动回复',
    // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
    9: '同步菜单',
  },
  wxGridConf: {
    columnsOption: {
      accountName: {
        value: 'accountName',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '公众号名称',
        width: 400,
        fixed: 'left',
        render(h, data) {
          const isQQ = data.row.type === '2';
          return (
            <div class="account-title">
              {data.row.faceUrl
                ? (<img class="account-avatar" src={data.row.faceUrl} />)
                : (<v-icon icon="{isQQ ? 'app_qq_line' : 'app_weixin_line'}" remote />)
              }
              <div class="account-info">
                <p class="account-info-name"><span>{data.row.accountName}</span>{data.row.verifyType ? (<v-icon name="basic_finish_fill" color="currentColor" class="verify-icon" remote size="14" />) : ''}</p>
                <span class="account-info-application">{isQQ ? i18n.t('公众号：{id}', { id: data.row.accountID }) : i18n.t('微信号：{account}', { account: data.row.wxAccount })}</span>
              </div>
            </div>
          );
        },
      },
      wxAppType: {
        value: 'wxAppType',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '公众号类型',
        width: 200,
        render(h, data) {
          const isQQ = data.row.type === '2';
          return <div>{(isQQ ? 'QQ' : i18n.t('微信')) + i18n.t(data.row.accountType == 1 ? '订阅号' : '服务号')}</div>;
        },
      },
      accountIntro: {
        value: 'accountIntro',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '公众号介绍',
        width: 400,
        render(h, data) {
          return <div>{data.row.intro || '-'}</div>;
        },
      },
      accountSetting: {
        value: 'accountSetting',
        // i18n-disable-next-line 字典 key，由消费方 $t() 翻译
        label: '公众号应用设置',
        width: 200,
        render(h, data) {
          const url = `/mp/application?accountID=${data.row.id}`;
          if (data.row.type === '2') {
            return (<span>-</span>);
          } if (data.row.appName) {
            return (<span>
              <span>{data.row.appName}
                <a href={url}>
                  <v-icon name="basic_edit_line" remote />
                </a>
              </span>
            </span>);
          }
            return (<span>
              <span class="setting-col">{i18n.t('未设置')}
                <a href={url} class="setting-col-icon">
                  <v-icon name="basic_edit_line" remote size="18" />
                </a>
              </span>
            </span>);
        },
      },
    },
  },
};
